import Typography from '@mui/material/Typography';
import { makeStyles } from '@mui/styles';
import React from 'react';
const useStyles = makeStyles({
    title: {
        fontSize: 'inherit',
        fontWeight: 500,
    },
});
const SectionTitle = ({ children }) => {
    const classes = useStyles();
    return (React.createElement(Typography, { className: classes.title, variant: "h4" }, children));
};
export default SectionTitle;
